import * as React from 'react';
import PropTypes from 'prop-types';
import MDTypography from './MDTypography';

function Title(props) {
  return (
    <MDTypography color='text' variant="h5" fontWeight="medium">
      {props.children}
    </MDTypography>
  );
}

Title.propTypes = {
  children: PropTypes.node,
};

export default Title;